import { db } from './firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';

export const addToCart = async (product, userId, quantity = 1) => {
  try {
    if (!userId) {
      return { success: false, requiresAuth: true };
    }

    const cartRef = doc(db, 'carts', userId);
    const cartSnap = await getDoc(cartRef);
    let cart = cartSnap.exists() ? cartSnap.data() : { items: [] };

    // Check if product already in cart (by id, selectedWeight, and beanType)
    const existingIndex = cart.items.findIndex(item =>
      item.id === product.id &&
      item.selectedWeight === product.selectedWeight &&
      item.beanType === product.beanType
    );
    if (existingIndex !== -1) {
      cart.items[existingIndex].quantity += quantity;
    } else {
      cart.items.push({ ...product, quantity });
    }

    await setDoc(cartRef, cart, { merge: true });

    return { success: true };
  } catch (error) {
    console.error('Error adding to cart:', error);
    return { success: false, error: error.message };
  }
};
